import { Mailcheck } from '@wkda/funnel-utils';
import { emailSuggestionConfiguration } from './configuration';

/**
 * @typedef {import('./types').IMailCheckOptions} IMailCheckOptions
 */

/**
 *
 * @param {IMailCheckOptions} props
 * @param {import('./types').IEmailSuggestionConfiguration} configuration
 */
export function mailCheck(_ref) {
  let {
    email,
    suggested,
    empty,
    locale
  } = _ref;
  let configuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emailSuggestionConfiguration;
  const {
    domainThreshold,
    secondLevelThreshold,
    topLevelThreshold,
    listDomains: domains,
    listTopLevelDomains,
    listSecondLevelDomains: secondLevelDomains,
    listTopLevelDomainsByLocales,
    listPrioritizedTopLevelDomains,
    fixedTopLevelDomains
  } = configuration;
  Mailcheck.domainThreshold = domainThreshold ?? Mailcheck.domainThreshold;
  Mailcheck.topLevelThreshold = topLevelThreshold ?? Mailcheck.topLevelThreshold;
  Mailcheck.secondLevelThreshold = secondLevelThreshold ?? Mailcheck.secondLevelThreshold;
  const topLevelDomains = [...new Set([...(listTopLevelDomainsByLocales[locale] ?? []), ...listPrioritizedTopLevelDomains, ...listTopLevelDomains])];
  Mailcheck.run({
    email,
    fixedTopLevelDomains,
    domains,
    secondLevelDomains,
    topLevelDomains,
    suggested,
    empty
  });
}